import { render, staticRenderFns } from "./institutional-investors.vue?vue&type=template&id=05868f7f"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./locale/institutional-investors-ar.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Finvesting%2Finstitutional-investors.vue&locale=ar&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./locale/institutional-investors-en.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Finvesting%2Finstitutional-investors.vue&locale=en&external"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHero: require('/vercel/path0/components/PageHero.vue').default,PageIntroBlock: require('/vercel/path0/components/PageIntroBlock.vue').default,CtaImage: require('/vercel/path0/components/ui/cta-image.vue').default,DubaiInvestmentFeatures: require('/vercel/path0/components/blocks/DubaiInvestmentFeatures.vue').default,DfmProductsGrid: require('/vercel/path0/components/blocks/DfmProductsGrid.vue').default})
